import { Toolbar } from 'react-admin';
import SaveAndRedirectButton from './SaveAndRedirectButton';

const CreditMemoCreateOrEditToolbar = () => {
  return (
    <Toolbar>
      <SaveAndRedirectButton />
    </Toolbar>
  );
};
export default CreditMemoCreateOrEditToolbar;
